import type { GetCourse200SummaryInstructorBasicInfo } from './getCourse200SummaryInstructorBasicInfo';
import type { GetCourse200SummaryInstructorSocial } from './getCourse200SummaryInstructorSocial';

/**
 * 강사 정보
 */
export type GetCourse200SummaryInstructor = {
  /** 사용자 기본 정보 */
  basicInfo: GetCourse200SummaryInstructorBasicInfo;
  /** 소셜 관계 정보 */
  social?: GetCourse200SummaryInstructorSocial;
};
